import { SubSpeciality } from "./SubSpeciality";

export class Doctor {
  public id : number;
  public userId : string;

  public firstName : string;
  public midName : string;
  public lastName : string;

  public subSpecialityId : number;

  public serviceProvided : string;
  public specialities : string;
  public scientificDegree : string;
  public experienceYears : string;

  public gender : string;
  public nationality : string;
  public distinguishedIn : string;
  public birthDate : string;

  public pictureUrl : string;

  public attachment : string;
  public attachmentName : string;
  public fileNameURL : string;

  public displayedAtMainPage : boolean;

  public SubSpeciality : SubSpeciality;

}
